export const root = document;
export const container = root.createElement('div');
// container.id = "myt-react-notify";
root.body.appendChild(container);
export const collection = {};
export const uid = (length = 6, range = 36) => {
	let unid = '';
	for (let i = 0; i < length; i++) {
		unid += Math.floor(Math.random() * range).toString(range);
	}
	return unid;
};
